module.exports = __webpack_public_path__ + "345578d86043dcfbf15b58d0aaaa7925.svg";